// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedDictionaryTag {
  american: {"enum_constant":"american"};
  british: {"enum_constant":"british"};
  dated: {"enum_constant":"dated"};
  formal: {"enum_constant":"formal"};
  informal: {"enum_constant":"informal"};
  literary: {"enum_constant":"literary"};
  offensive: {"enum_constant":"offensive"};
  slang: {"enum_constant":"slang"};
}

export type DictionaryTagId = keyof IParsedDictionaryTag;
export type DictionaryTagData = IParsedDictionaryTag[DictionaryTagId];
const data: DictionaryTagData[] = [{"enum_constant":"american"},{"enum_constant":"british"},{"enum_constant":"dated"},{"enum_constant":"formal"},{"enum_constant":"informal"},{"enum_constant":"literary"},{"enum_constant":"offensive"},{"enum_constant":"slang"}];
export default data;
